NS('fishersci.components').ShareEmail = (function () {

    var settings = {};

    return {

        errorPrefix:	'Please enter ',
        errorMessages:	{
            emailSubject:	'a subject.',
            senderName:	'your name.',
            emailFrom:	'a valid email address',
            emailTo:	'a valid email address'
        },
        defaults:	{
            domElementListener: {},
            emailFormShowing:	false,
            domForm:	{},
            requiredFields: {},
            emailFields:	{},
            origin:	'product',
            modalTitle:	'Email this product',
            subjectPrefix:	'Fisher Scientific - ',
            subject:	document.title,
            hiddenFields:	{},
            ajaxAction:	'/store1/cart/sharecartservice/',
            emailButton:	{}
        },

        init:	function(){

            dev.log("ShareViaEmail init()");

            var _SELF = this;
            var options = arguments[0] || {};

            //Share Email
            $(document).on("click", "#submitEmailShare", function(){
                if(_SELF.validateEmailForm()){
                    _SELF.submitEmailForm();
                }
            });

            //Hold instance of DOM element _SELF.will trigger modal, etc
            _SELF.defaults.domElementListener = $('.send_email');

            //Merge defaults with options
            settings = $.extend(_SELF.defaults, options);

            //submit button
            settings.emailButton = $('#shareEmailInnerContainer #submitEmailShare');

            //Add listener to email element */
            $(document).on("click",".send_email", function(){
                _SELF.showEmailForm();
            });

        },
        showEmailForm:	function(){
            dev.log("showEmailForm() called");

            var _SELF = this;
            var widthPercent = '90%';
            var heightPercent = '100%';
            var sendMessage = '';

            //Update image - this will vary
            $('#shareViaEmailContainer .required').each(function(){
                $(this).removeClass('error');
                $(this).next('span').addClass('hide');
            });

            //Need to resize the popped up modal properly based on breakpoint.

            if(fishersci.Common.inDesktopBreakpoint()){
                widthPercent='50%';
            }
            else if(fishersci.Common.inTabletBreakpoint()){
                widthPercent='70%';
                heightPercent = '70%'
            }
            else if (fishersci.Common.inMobileBreakpoint()){
                widthPercent='70%';
                heightPercent = '60%'
            }

            $.colorbox({
                inline:true,
                href: "#shareEmailInnerContainer",
                width: widthPercent,
                height: heightPercent
            });

            if(typeof env.firstName !== "undefined"){
                $('#senderName').val(env.firstName + ' ' +env.lastName);
            }

            $("#cboxWrapper").on("click",'#qa_modalClose_Share,#qa_toolbarCloseIco_Share',function(){
                _SELF.removeEmailForm();
            });

        },

        removeEmailForm:	function(){
            dev.log('removeEmailForm() called');
            $.colorbox.close();
        },

        validateEmailForm:	function(){
            dev.log("validateEmailForm() called");

            var _SELF = this;
            var errors = 0;

            //Loop through required fields and test */
            $('#cboxWrapper #shareEmailInnerContainer .required').each(function(){
                if($(this).attr("name") == "emailTo"
                    ||$(this).attr("name") == "emailFrom" ){
                    if( !validateEmailFormat($(this).val()) ){
                        errors++;
                        $(this).addClass('error');
                        $(this).next('label').removeClass('hide');
                    }
                    else{
                        $(this).removeClass('error');
                        $(this).next('label').addClass('hide');
                    }
                }
                else if($(this).val() === ""){
                    errors++;
                    $(this).addClass('error');
                    $(this).next('label').removeClass('hide');
                } else {
                    $(this).removeClass('error');
                    $(this).next('label').addClass('hide');
                }
            });

            if(errors === 0){
                dev.log("validateEmailForm passed...");
                return true;
            } else {
                dev.log("validateEmailForm failed...");
                return false;
            }
        },
        submitEmailForm:	function(){
            dev.log('submitEmailForm() called');
            var data = $("#cboxWrapper #shareEmailInnerContainer #sharePageForm").serialize();
            $.ajax({
                url: settings.ajaxAction ,
                dataType: 'json',
                type: 'post',
                data: data,
                success: function( data ) {
                    console.log( data );

                },
                beforeSend:	function(){
                    fishersci.Common.addSpinnerToElement($('#emailFormBody'),{classes:' float_left'});
                },
                complete:	function(){
                    fishersci.Common.removeSpinnerFromElement($('#emailFormBody'));
                    try {
                        //Pass back event to SC
                        if(Analytics){
                            Analytics.trackShareThisSubmit({},'email');
                        }
                    }catch (e){
                        console.log("Issue with trackShareThisSubmit()");
                        console.log(e);
                    }

                    //Close the modal
                    $.colorbox.close();
                },
                error : function(){
                    console.log("There was an issue completing this action");
                }
            })
        }
    }
}());